import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  data: []
};

const locations = (state = initialState, action) => {
  switch (action.type) {
    case constant.LOCATIONS_LOADING:
      return { ...state, loading: true };
    case constant.ADD_LOCATIONS_LIST:
      return { loaded: true, loading: false, data: action.payload };
    case constant.ADD_LOCATION:
      let orders = state.data;
      let index = orders.findIndex(data => data._id == action.payload._id);
      if (index > -1) {
        orders[index] = action.payload;
      } else {
        orders = [action.payload, ...orders];
      }
      return { loaded: true, loading: false, data: orders };
    default:
      return state;
  }
}



export default locations;